<template>
  <span id="manage-shipment-more-actions-section">
    <el-dropdown id="manage-shipment-more-actions-dropdown" v-show="displayDropdown">
      <el-button class="manage-shipment-more-actions-button" type="success" plain size="mini">{{ $t('customerService.shipment.closingActions') }}<i class="el-icon-arrow-down el-icon--right" /></el-button>
      <el-dropdown-menu slot="dropdown">
        <close-billing is-drop-down-item @displayDropdown="displayDropdown = true" ref="closeBilling" />
        <rebill-invoice ref="reBillInvoice" />
        <run-rating is-drop-down-item @displayDropdown="displayDropdown = true" ref="runRating" />
        <undo-billing is-drop-down-item @displayDropdown="displayDropdown = true" ref="undoBilling" />
        <update-all-bill-to is-drop-down-item @displayDropdown="displayDropdown = true" ref="updateAllBillTo" />
      </el-dropdown-menu>
    </el-dropdown>
  </span>
</template>

<script>
import CloseBilling from './CloseBilling';
import RunRating from './RunRating';
import UndoBilling from './UndoBilling';
import UpdateAllBillTo from './UpdateAllBillTo';
import RebillInvoice from './RebillInvoice';

export default {
  name: 'ClosingActions',
  components: {
    CloseBilling,
    RunRating,
    UndoBilling,
    UpdateAllBillTo,
    RebillInvoice
  },
  data() {
    return {
      displayDropdown: false
    };
  },
};
</script>
